// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"4cc14a91","513":"b4068d59","575":"a239fce3","697":"7304b353","770":"2a244c47","787":"f01d19ca","823":"22f0398e","938":"518b389d"}[chunkId] + ".chunk.js";
};